import { render } from "./Sailgene.vue?vue&type=template&id=20116a6a&scoped=true"
import script from "./Sailgene.vue?vue&type=script&lang=js"
export * from "./Sailgene.vue?vue&type=script&lang=js"

import "./Sailgene.vue?vue&type=style&index=0&id=20116a6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20116a6a"]])

export default __exports__